// アプリ本体(env.jsなど)の最初
console.log("[env.js] Starting up...", new Date(), window.APP_CONFIG);

// 環境変数をローカルストレージに永続化する
const initializeConfig = () => {
  // config.jsから読み込めなかった場合は、ローカルストレージから復元
  if (!window.APP_CONFIG) {
    const savedConfig = localStorage.getItem("APP_CONFIG");
    if (savedConfig) {
      window.APP_CONFIG = JSON.parse(savedConfig);
    }
  }

  // 新しい設定が読み込めたらローカルストレージに保存
  if (window.APP_CONFIG) {
    localStorage.setItem("APP_CONFIG", JSON.stringify(window.APP_CONFIG));
  }
};

// 環境変数を取得する関数
const getConfig = () => {
  initializeConfig();
  return window.APP_CONFIG;
};

export const URL = getConfig()?.API_URL;
export const COGNITO_USER_POOL_ID = getConfig()?.COGNITO_USER_POOL_ID;
export const COGNITO_CLIENT_ID = getConfig()?.COGNITO_CLIENT_ID;
